export default __webpack_public_path__ + "9b0254d2b3056283b3bc30c1766fffc5.jpg";